import { render } from "./Servicios.vue?vue&type=template&id=54cb468e"
import script from "./Servicios.vue?vue&type=script&lang=js"
export * from "./Servicios.vue?vue&type=script&lang=js"

import "./Servicios.vue?vue&type=style&index=0&id=54cb468e&lang=css"
script.render = render

export default script